import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmuw687r8b: FaireProductEntity = {
  token: "p_hmuw687r8b",
  type: "product",
  name: "Greyhaven Incense Cones – Salt Air, Moss & Pine | Clean Burning, 20-Pack",
  brandToken: "b_32d2mbpi",
  brandName: "Misc Goods Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/5923f86892bc64d2148411a8f870addce400ebccc27b7a4e939af95b0c35418a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f459b1e5f0252c3a47d453007745be9e3b736b09f4b7298d0d2f9933d7749ced.jpeg",
    "https://cdn.faire.com/fastly/27f733f6ab103655cb6f63f13fde9caf0b980fa0039c7aaef9c6d3ee98661c76.jpeg",
    "https://cdn.faire.com/fastly/d0fa1dc21248ec2ca1eee25a457b796a111ce0b57e3dc360c2636712df8580a0.jpeg",
  ],
  priceDollars: 10,
  description:
    "Bring the coast into your space. Greyhaven Incense Cones carry the cool, spicy tones of a seaside town nestled against the forest. Imagine walking out of Underhill’s woods and into salt air, mossy stone streets, spice markets, and morning rain. Each cone fills your space with a rich, earthy blend of ocean breeze, pine, brine, and soft spice — grounding, calming, and deeply atmospheric.\n- Includes 20 incense cones per box  \n- Burn time: 35+ minutes per cone  \n- Fragrance notes: salt air, pine, green moss, spice, white wine  \n- Crafted from a blend of 12 premium essential oils  \n- Deep, long-lasting scent inspired by coastal landscapes  \n- Great for daily rituals, meditation, or unwinding at home  \n- Clean-burning and free of synthetic additives  \n- Made in the USA  \n\nKeywords: Greyhaven incense, ocean-inspired incense, earthy home fragrance, incense cones, coastal scent, natural incense, meditation fragrance, clean burning incense, made in USA",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:56.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
